import React from "react";
import { Routes, Route } from "react-router-dom";

import Relations from "./Relations";
import RelationCreateEdit from "./RelationCreateEdit";
import RelationDetails from "./RelationDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<Relations />} />
			<Route path='/create' element={<RelationCreateEdit />} />
			<Route path='/:id/edit' element={<RelationCreateEdit />} />
			<Route path='/:id/details' element={<RelationDetails />} />
		</Routes>
	);
};

export default index;
